<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>통계</h2>
            </div>
            <div class="sch_condition_wrap" v-if="state.tabIdx !== 2">
                <div class="left">
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" v-model="state.startDate" @change.prevent="chageDate(0)" />
                        </div>
                        <div class="select_date">
                            <input type="date" v-model="state.endDate" @change.prevent="chageDate(1)" />
                        </div>
                    </div>
                    <button type="button" @click="excelDown"><img src="img/excel_icon.png" alt=" 엑셀 다운로드" /></button>
                </div>
            </div>
            <div class="tab_wrap">
                <button type="button" :class="{ active: state.tabIdx === 1 }" @click="state.tabIdx = 1">접속자</button>
                <button type="button" :class="{ active: state.tabIdx === 2 }" @click="state.tabIdx = 2">GA</button>
                <button type="button" :class="{ active: state.tabIdx === 3 }" @click="state.tabIdx = 3">시민제보</button>
                <button type="button" :class="{ active: state.tabIdx === 4 }" @click="state.tabIdx = 4">시민협력</button>
                <button type="button" :class="{ active: state.tabIdx === 5 }" @click="state.tabIdx = 5">캠페인/이벤트</button>
            </div>

            <UserTab :startDate="state.startDate" :endDate="state.endDate" v-if="state.tabIdx === 1"></UserTab>
            <GATab v-else-if="state.tabIdx === 2"></GATab>
            <ReportTab :startDate="state.startDate" :endDate="state.endDate" v-else-if="state.tabIdx === 3"></ReportTab>
            <ActivityTab :startDate="state.startDate" :endDate="state.endDate" v-else-if="state.tabIdx === 4"></ActivityTab>
            <ActivityTabForEvent :startDate="state.startDate" :endDate="state.endDate" v-else-if="state.tabIdx === 5"></ActivityTabForEvent>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        reactive,
        apiService,
        Header,
        Left,
        types,
        getMessageByCode,
        ActivityTab,
        ActivityTabForEvent,
        GATab,
        ReportTab,
        UserTab,
        ModalDefault,
        CommonUtils,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ActivityTab, ActivityTabForEvent, GATab, ReportTab, UserTab, ModalDefault },
        setup() {
            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setDate(today.getDate() - 90);

            const state = reactive({
                tabIdx: 1 as number,
                startDate: dayAgo.toISOString().split("T")[0] as string,
                endDate: today.toISOString().split("T")[0] as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const excelDown = async () => {
                let res = null;
                switch (state.tabIdx) {
                    case 1:
                        {
                            const param: types.ReqParamForDashboard = {
                                startDate: state.startDate,
                                endDate: state.endDate,
                            };

                            res = await apiService.statistics.userExportExcel(param);
                        }
                        break;
                    case 3:
                        {
                            const param: types.ReqParamForDashboard = {
                                startDate: state.startDate,
                                endDate: state.endDate,
                            };

                            res = await apiService.statistics.reportExportExcel(param);
                        }
                        break;
                    case 4:
                        {
                            const param: types.ReqParamForDashboard = {
                                startDate: state.startDate,
                                endDate: state.endDate,
                                type: 1,
                            };

                            res = await apiService.statistics.boardExportExcel(param);
                        }
                        break;
                    case 5:
                        {
                            const param: types.ReqParamForDashboard = {
                                startDate: state.startDate,
                                endDate: state.endDate,
                                type: 2,
                            };

                            res = await apiService.statistics.boardExportExcel(param);
                        }
                        break;
                }

                try {
                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const chageDate = (type: 0 | 1) => {
                if (state.startDate > state.endDate) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            return { state, excelDown, chageDate, closeModal, CommonUtils };
        },
    };
</script>
